import React from 'react'
import { connect } from 'react-redux'
import { Form} from 'semantic-ui-react'
import { Text, Translate, LanguageContext } from '../helpers/language';
import csc from 'country-state-city'


const invoiceTypes = [
  {id: 0, value: 'false', name: 'billing_info_invoice_type_receipt'},  
  {id: 1, value: 'true', name: 'billing_info_invoice_type_invoice'},
]

/** 
 * Needs the following passed as props:
 * handleChange callBack to the change of   
 * 
**/
class BillingInfoForm extends React.Component {
  
  constructor(props){
    super(props)
    const billingInfo = props.billingInfo ? props.billingInfo : {}
    this.state = {    
        is_invoice: billingInfo.is_invoice ? billingInfo.is_invoice : 'true',   
        countries: csc.getAllCountries(), 
        address: billingInfo.address ? billingInfo.address : '',
        address_complement: billingInfo.address_complement ? billingInfo.address_complement : '',
        zip_code: billingInfo.zip_code ? billingInfo.zip_code : '',
        city: billingInfo.city ? billingInfo.city : '',
        state: billingInfo.state ? billingInfo.state : '',
        country: billingInfo.country ? billingInfo.country : 107,
        country_code: billingInfo.country_code ? billingInfo.country_code : 'IT',
        vat_number: billingInfo.vat_number ? billingInfo.vat_number : '',
        //adamo specific metadata
        Fiscal_code: billingInfo.Fiscal_code ? billingInfo.Fiscal_code : '',
        Fe_code: billingInfo.Fe_code ? billingInfo.Fe_code : '',
        Pec: billingInfo.Pec ? billingInfo.Pec : '',
        fe_code_or_pec: billingInfo.Fe_code ? billingInfo.Fe_code : billingInfo.Pec ? billingInfo.Pec : '',
        is_error: billingInfo.is_error ? billingInfo.is_error : false,
        errors: billingInfo.errors ? billingInfo.errors : {
            address: '',
            zip_code: '',
            city: '',
            state: '',
            country: '',
            vat_number: '',
            Fiscal_code: '',
            Pec: '',
            Fe_code: '',
            fe_code_or_pec: ''
        },
        is_data_ok: this.checkData(billingInfo)
    }  

    if(this.props.handleStateChange)
        this.props.handleStateChange(this.state) 
  }

  filterRegionsfromStatesList(list) {
    return list
  }

  async handleInvoiceTypeChanged(event) {
    event.preventDefault();      
    const value = event.target.value;
    await this.setState({is_invoice: value, errors : {
      address: '',
      zip_code: '',
      city: '',
      state: '',
      country: '',
      vat_number: '',
      Fiscal_code: '',
      Pec: '',
      Fe_code: '',
      fe_code_or_pec: ''
      }
    });  
    this.handleStateChange();  
  }

  async handleAddressChanged(event) {
    event.preventDefault();
    const value = event.target.value
    if (value === '' && this.state.is_invoice === 'true')
      await this.setState({errors: {...this.state.errors, address: Translate(this.context,'billing_info_address_required')}})
    else
        await this.setState({errors: {...this.state.errors, address: ''}})
    await this.setState({address: value});
    this.handleStateChange();
  }

  async handleAddressComplementChanged(event) {
    event.preventDefault();
    const value = event.target.value
    await this.setState({address_complement: value});
    this.handleStateChange()
  }

  async handleZipChanged(event) {
    event.preventDefault();
    const value = event.target.value
    if (value === '' && this.state.is_invoice === 'true')
        await this.setState({errors: {...this.state.errors, zip_code: Translate(this.context,'billing_info_address_required')}})
    else
        await this.setState({errors: {...this.state.errors, zip_code: ''}})
    await this.setState({zip_code: value});
    this.handleStateChange()
  }

  async handleCityChanged(event) {
    event.preventDefault();
    const value = event.target.value
    if (value === '' && this.state.is_invoice === 'true')
        await this.setState({errors: {...this.state.errors, city: Translate(this.context,'billing_info_address_required')}})
    else
        await this.setState({errors: {...this.state.errors, city: ''}})
    await this.setState({city: value});
    this.handleStateChange()
  }

  async handleStateChanged(event) {
    event.preventDefault();
    const value = event.target.value
    if (value === '' && this.state.is_invoice === 'true')
        await this.setState({errors: {...this.state.errors, state: Translate(this.context,'billing_info_address_required')}})
    else
        await this.setState({errors: {...this.state.errors, state: ''}})
    await this.setState({state: value});
    this.handleStateChange()
  }

  async handleCountryChanged(event) {
    event.preventDefault();
    const code = event.target.value
    if (code === '')
        await this.setState({errors: {...this.state.errors, country: Translate(this.context,'billing_info_address_required')}})
    else
        await this.setState({errors: {...this.state.errors, country: ''}})
    const country = csc.getCountryByCode(code)
    await this.setState({country: country.id, country_code: code});
    this.handleStateChange()
  }

  async handlePecChanged(event) {
    event.preventDefault();
    const value = event.target.value
    if (value === '' && this.state.Fe_code === '' && this.state.country_code === 'IT')
        await this.setState({errors: {...this.state.errors, Pec: Translate(this.context,'billing_info_pec_or_code_required'), Fe_code: Translate(this.context,'billing_info_pec_or_code_required')}})
    else
        await this.setState({errors: {...this.state.errors, Pec: '', Fe_code: '' }})
    await this.setState({Pec: value});
    this.handleStateChange()
  }

  async handleVatChanged(event) {
    event.preventDefault();
    const value = event.target.value
    if (value === '')
        await this.setState({errors: {...this.state.errors, vat_number: Translate(this.context,'billing_info_vat_number_required')}})
    else
        await this.setState({errors: {...this.state.errors, vat_number: ''}})
    await this.setState({vat_number: value});
    this.handleStateChange()
  }

  async handleFcChanged(event) {
    event.preventDefault();
    const value = event.target.value.toUpperCase();
    if (value === '' && this.state.is_invoice !== 'true')
        await this.setState({errors: {...this.state.errors, Fiscal_code: Translate(this.context,'billing_info_fiscal_code_required')}})
    else 
        await this.setState({errors: {...this.state.errors, Fiscal_code: ''}})
    await this.setState({Fiscal_code: value});
    this.handleStateChange()
  }

  async handleFeCodeChanged(event) {
    event.preventDefault();
    const value = event.target.value
    if (value === '' && this.state.Pec === '' && this.state.country_code === 'IT')
        await this.setState({errors: {...this.state.errors, Fe_code: Translate(this.context,'billing_info_pec_or_code_required'), Pec: Translate(this.context,'billing_info_pec_or_code_required')}})
    else
        await this.setState({errors: {...this.state.errors, Fe_code: '', Pec: ''}})
    await this.setState({Fe_code: value});
    this.handleStateChange()
  }

  async handleFeCodeOrPecChanged(event) {
    event.preventDefault();
    const value = event.target.value
    await this.setState({fe_code_or_pec: value});    
    if (value === '') {
      await this.setState({errors: {...this.state.errors, fe_code_or_pec: Translate(this.context,'billing_info_pec_or_code_required') }})
      await this.setState({Pec: ''});
      await this.setState({Fe_code: ''});
      
    } else if (value.match(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/)) {      
      await this.setState({Pec: value});
      await this.setState({Fe_code: ''});    
      await this.setState({errors: {...this.state.errors, fe_code_or_pec: ''}})  
    } else {
      await this.setState({Pec: ''});
      await this.setState({Fe_code: value});    
      await this.setState({errors: {...this.state.errors, fe_code_or_pec: ''}})  
    }
    this.handleStateChange()
  }

  async handleStateChange() {
      await this.setState({is_error: this.hasErrors(this.state), is_data_ok: this.checkData(this.state)})
      if(this.props.handleStateChange)
        this.props.handleStateChange(this.state)
  }

  async preventReturnPropagation(event) {
    if (event.keyCode === 13)
      event.preventDefault()
  }

  hasErrors(data) {
      return !data || (
      data.is_invoice === 'true' && (
        data.errors && (
          data.errors.address !== '' ||
          data.errors.zip_code !== '' || 
          data.errors.city !== '' ||
          data.errors.state !== '' ||
          data.errors.country !== '' ||
          data.errors.vat_number !== '' ||
          data.errors.Fiscal_code !== '' ||
          data.errors.fe_code_or_pec !== '' ||
          data.errors.Pec !== '')
        ) || 
        (
          data.is_invoice === 'false' && 
          data.errors && 
          data.errors.Fiscal_code !== '' 
        )
      )
  }

  checkData(data) {
    if (data.is_invoice === 'false' && data.Fiscal_code && !data.Fiscal_code.match(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i)) {
      this.setState({errors: {...this.state.errors, Fiscal_code: Translate(this.context,'billing_info_fiscal_code_format_invalid')}});
      return false;
    }
    const ret = data && Object.keys(data).length > 0 && !this.hasErrors(data) && ( 
      ( data.is_invoice === 'true' &&
        data.address != null && data.address.length > 0 &&
        data.zip_code != null && data.zip_code.length > 0 &&
        data.city != null && data.city.length > 0 &&
        data.state != null && data.state.length > 0 &&
        data.country != null && data.country > 0 &&
        data.vat_number != null && data.vat_number.length > 0 &&
      ( data.Pec != null && data.Pec.length > 0 || data.Fe_code != null &&  data.Fe_code.length > 0 || data.country_code !== 'IT')
      ) || 
      ( data.is_invoice === 'false' && data.Fiscal_code )
    )     
    return ret;
  }

  render() {
    const is_invoice = this.state.is_invoice;
    return (
        <>
          <Form.Field>
            <label style={{textAlign:'left'}}><Text tid="billing_info_invoice_type" /></label>
            <select value={is_invoice} onChange={this.handleInvoiceTypeChanged.bind(this)} style={{marginBottom:'10px'}}>
              {
                invoiceTypes.map((curType) => 
                    <option key={curType.id} value={curType.value}>{Translate(this.context, curType.name) ? Translate(this.context, curType.name) : curType.name}</option>
                )
              }
            </select>
          </Form.Field>
          { is_invoice === 'false' &&                
              <Form.Field>
                  <label style={{textAlign:'left'}}><Text tid="billing_info_fiscal_code" /></label>
                  <Form.Input type="text" 
                              value={this.state.Fiscal_code} 
                              autoComplete="fiscal_code"
                              name="fiscal_code" 
                              onChange={this.handleFcChanged.bind(this)} 
                              onKeyDown={this.preventReturnPropagation.bind(this)}
                              placeholder={Translate(this.context,'billing_info_fiscal_code')} 
                              error={this.state.errors.Fiscal_code !== '' ? this.state.errors.Fiscal_code : false} 
                  /> 
              </Form.Field>            
          }
          <Form.Field>   
                <label style={{textAlign:'left'}}><Text tid="billing_info_address" />{ is_invoice === 'false' && <> (<Text tid="optional" />)</>}</label>    
                <Form.Input type="text" 
                            value={this.state.address} 
                            autoComplete="street_and_number"
                            name="address" 
                            onChange={this.handleAddressChanged.bind(this)} 
                            onKeyDown={this.preventReturnPropagation.bind(this)}
                            placeholder={Translate(this.context,'billing_info_address_placeholder')} 
                            error={this.state.errors.address !== '' ? this.state.errors.address : false} 
                /> 
                <Form.Input type="text" 
                            value={this.state.zip_code} 
                            autoComplete="postal_code"
                            name="zip_code" 
                            onChange={this.handleZipChanged.bind(this)} 
                            onKeyDown={this.preventReturnPropagation.bind(this)}
                            placeholder={Translate(this.context,'billing_info_zip_code')} 
                            error={this.state.errors.zip_code !== '' ? this.state.errors.zip_code : false} 
                />
                <Form.Input type="text" 
                            value={this.state.city} 
                            autoComplete="city"
                            name="city" 
                            onChange={this.handleCityChanged.bind(this)} 
                            onKeyDown={this.preventReturnPropagation.bind(this)}
                            placeholder={Translate(this.context,'billing_info_city')} 
                            error={this.state.errors.city !== '' ? this.state.errors.city : false} 
                />
                <Form.Input type="text" 
                  value={this.state.state} 
                  autoComplete="state"
                  name="state" 
                  onChange={this.handleStateChanged.bind(this)} 
                  onKeyDown={this.preventReturnPropagation.bind(this)}
                  placeholder={Translate(this.context,'billing_info_state')} 
                  error={this.state.errors.state !== '' ? this.state.errors.state : false} 
                />
                
          </Form.Field>  
          { is_invoice === 'true' && <div>                        
              <Form.Field>
                  <label style={{textAlign:'left'}}><Text tid="billing_info_vat_number" /></label>
                  <Form.Input type="text" 
                              value={this.state.vat_number} 
                              autoComplete="vat_number"
                              name="vat_number" 
                              onChange={this.handleVatChanged.bind(this)} 
                              onKeyDown={this.preventReturnPropagation.bind(this)}
                              placeholder={Translate(this.context,'billing_info_vat_number')} 
                              error={this.state.errors.vat_number !== '' ? this.state.errors.vat_number : false} 
                  /> 
              </Form.Field>
              <Form.Field>
                  <label style={{textAlign:'left'}}><Text tid="billing_info_fe_code_or_pec" /></label>
                  <Form.Input type="text" 
                              value={this.state.fe_code_or_pec} 
                              autoComplete="fe_code_or_pec"
                              name="fe_code_or_pec" 
                              onChange={this.handleFeCodeOrPecChanged.bind(this)}  
                              onKeyDown={this.preventReturnPropagation.bind(this)}                           
                              placeholder={Translate(this.context,'billing_info_fe_code_or_pec')}
                              error={this.state.errors.fe_code_or_pec !== '' ? this.state.errors.fe_code_or_pec : false} 
                  /> 
              </Form.Field>                   
          </div> 
        }
      </>
    )
  }
}

BillingInfoForm.contextType = LanguageContext;

BillingInfoForm.propTypes = {

}

const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps)(BillingInfoForm)
